import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default class extends Controller {
  connect() {
    new Swiper(this.element, {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 'auto',
      loop: true,
      speed: 2000,
      centeredSlides: true,
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      on: {
        init: function () {
          document.querySelector('.swiper-wrapper').style.visibility = 'visible';
        }
      }
    });
  }
}
